import React, {useEffect} from "react";
import Image1 from "../../../imgs/htmlAdvert/01.png";
import Image2 from "../../../imgs/htmlAdvert/02.png";
import Image4 from "../../../imgs/htmlAdvert/04.png";
import Image1Svg from "../../../imgs/htmlAdvert/01.svg";
import Image2Svg from "../../../imgs/htmlAdvert/02.svg";
import Image3Svg from "../../../imgs/htmlAdvert/03.svg";
import ImageButton from "../../../imgs/htmlAdvert/button.svg";
import ImageNumber from "../../../imgs/htmlAdvert/number.svg";

export const HTMLAdvert = ({hide, onClick}) => {
  let index = 2 - 1;
  let iterations = 0;

  const updateImg = () => {
    const screens = document.querySelectorAll(".htmlAdvertscreen");
    index++;
    iterations++;
    if (index >= screens.length) {
      index = 0;
    }
    screens.forEach((screen) => {
      screen.classList.remove("display");
    });
    screens[index].classList.add("display");
  };

  useEffect(() => {
    const interval = setInterval(updateImg, 5000);

    return () => clearInterval(interval);
  }, []);

  return !hide && (
    <div className="htmlAdvert">
      <div className="htmlAdvertcontainer">
        <div className="htmlAdvertframe"></div>
        <a
          href="https://www.medicines.ie/medicines/vydura-75-mg-oral-lyophilisate-35326/spc"
          target="_blank"
          onClick={onClick}
          className="htmlAdvertbutton"
        >
          <img src={ImageButton} alt="" />
        </a>
        <img src={ImageNumber} alt="" className="htmlAdvertnumber" />
        <img src={Image2} alt="" className="htmlAdvertbg2" />

        {/* <!-- ==========   SCREENS   ========== --> */}

        {/* <!-- ==========   1   ========== --> */}

        <section className="htmlAdvertscreen">
          <div className="htmlAdvertframe"></div>
          <img src={Image1} alt="" className="htmlAdvertbg" />
          <img src={Image4} alt="" className="htmlAdvertbg" />
          <img src={Image1Svg} alt="" className="htmlAdvertbg" />
        </section>

        {/* <!-- ==========   2   ========== --> */}

        <section className="htmlAdvertscreen">
          <div className="htmlAdvertframe"></div>
          <img src={Image2Svg} alt="" className="htmlAdvertbg" />
        </section>

        {/* <!-- ==========   3   ========== --> */}

        <section className="htmlAdvertscreen">
          <div className="htmlAdvertframe"></div>
          <img src={Image3Svg} alt="" className="htmlAdvertbg" />
        </section>

        {/* <!-- ==========   4   ========== --> */}

      </div>
    </div>
  );
};